import {
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader
} from "vue-flux";

export default {
    name: "Carousel",

    components: {
        VueFlux,
        FluxCaption,
        FluxControls,
        FluxIndex,
        FluxPagination,
        FluxPreloader
    },

    props: {
        width: Number
    },

    data: () => {
        return {
            vfOptions: {
                autoplay: true,
                delay: 5000
            },
            vfTransitions: ["zip", "concentric", "round2"],
            vfCaptions: [
                {
                    text:
                        "Ocupa-te de <b>visul</b> tău<br /> Lasă grijile în seama noastră",
                    id: 1
                },
                {
                    text:
                        "Țintește cât mai sus <br />Cu noi drumul tău e în <b>siguranță</b>",
                    id: 2
                },
                {
                    text:
                        "Oriunde ai fi,<br />Conectează-te la o lume <b>sigură</b>",
                    id: 3
                }
            ]
        };
    },

    computed: {
        vfImages: function() {
            if (!this.width) {
                return;
            }
            if (this.width < 576) {
                console.log("Mobile");
                return [
                    "img/client/mobile_carousel_1.jpg",
                    "img/client/mobile_carousel_2.jpg",
                    "img/client/mobile_carousel_3.jpg"
                ];
            } else {
                console.log("Desktop");
                return [
                    "img/client/poza1.jpg",
                    "img/client/poza2.jpg",
                    "img/client/poza3.jpg"
                ];
            }
        }
    },

    methods: {}
};
